import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./TextCardFragment.module.css";
import { CardFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/LoadingCardFragment/LoadingCardFragment";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import {
  useFormatFieldValue,
  type FieldFormat,
} from "@coworker/apprestructured/src/task-management/hooks/useFormatFieldValue";

export type TextCardFragmentConfigProps = {
  field: string;
  format?: FieldFormat;
};

type TextCardFragmentProps = {
  configProps: TextCardFragmentConfigProps;
  commonProps: CardFragmentCommonProps;
};

function TextCardFragment({ configProps, commonProps }: TextCardFragmentProps) {
  const { field, format } = configProps;
  const { task } = commonProps;
  const formatFieldValue = useFormatFieldValue();

  if (!field) {
    return null;
  }

  const rawText = getTypedValue<string>(getByPath(task, field));

  if (isLoading(rawText)) {
    return <LoadingCardFragment />;
  } else if (!rawText) {
    return null;
  }

  const text = formatFieldValue(rawText, format);

  return <FixaText className={styles["root"]}>{text}</FixaText>;
}

export default TextCardFragment;
